export enum InputTypeEnum{
    TEXT = "Text",
    NUMBER = "Number",
    PHONENUMBER = "Phonenumber",
    EMAIL = "Email",
    PASSWORD = "Password"
}